import React, { useState, useEffect } from 'react'

export const RenameModal = ({ isOpen, onClose, currentName = '', onRename, loading = false, folderId }) => {
	const [name, setName] = useState(currentName)
	const [error, setError] = useState('')

	useEffect(() => {
		if (isOpen) {
			setName(currentName)
			setError('')
		}
	}, [isOpen, currentName])

	const handleRename = () => {
		if (!name.trim() || name.trim() === currentName.trim()) {
			setError('Digite um nome diferente')
			return
		}
		setError('')
		onRename(name.trim())
	}

	if (!isOpen) return null

	return (
		<div className='tw-fixed tw-inset-0 tw-bg-black/40 tw-z-50 tw-flex tw-items-center tw-justify-center'>
			<div className='tw-bg-white tw-rounded-xl tw-shadow-lg tw-p-6 tw-w-[634px]'>
				<div className='tw-text-lg tw-font-medium tw-mb-6'>Renombrar Carpeta</div>
				<div className='tw-mb-4'>
					<label className='tw-block tw-font-bold tw-mb-1'>Nuevo nombre</label>
					<input className='border tw-rounded-lg tw-px-3 tw-py-2 tw-w-full' value={name} onChange={e => setName(e.target.value)} disabled={loading} />
				</div>
				{error && <div className='tw-text-red-500 tw-mb-2'>{error}</div>}
				<div className='tw-flex tw-justify-end tw-gap-3'>
					<div
						onClick={onClose}
						className='border tw-px-4 tw-py-2 tw-text-gray-700 hover:tw-bg-gray-50 tw-cursor-pointer tw-rounded-lg'
						disabled={loading}
					>
						Cancelar
					</div>
					<div
						onClick={handleRename}
						className={`tw-bg-purple-500 tw-text-white tw-px-4 tw-py-2 hover:tw-bg-purple-700 tw-cursor-pointer tw-rounded-lg ${
							!name.trim() || name.trim() === currentName.trim() || loading ? 'tw-opacity-50' : ''
						}`}
						disabled={!name.trim() || name.trim() === currentName.trim() || loading}
						style={{ pointerEvents: !name.trim() || name.trim() === currentName.trim() || loading ? 'none' : 'auto' }}
					>
						{loading ? 'Renomeando...' : 'Renomear'}
					</div>
				</div>
			</div>
		</div>
	)
}

export default RenameModal
